/**
 * Mamm B2B-Modal (Lead-Drawer, 3 Schritte)
 * ============================================================================
 * Schritt 1 (Person: Vorname/Nachname/E-Mail)
 *   → Klaviyo-Event "B2B Lead Anfrage" (Safety-Net: auch Abbrecher sind im
 *     Nurture-Flow) → weiter zu Schritt 2
 * Schritt 2 (Firma/Branche/Telefon/Bedarf/Webseite + Marketing-Checkbox)
 *   → parallel, alle best-effort (blockieren NIE):
 *     a) POST an Lead-Endpoint (operations.mammpro.com → Odoo crm.lead)
 *     b) Klaviyo-Event "B2B Lead qualifiziert" (Profil-Properties)
 *     c) Klaviyo-Listen-Subscribe NUR bei Marketing-Checkbox (Consent)
 *     d) Shopify-Kontaktformular (E-Mail-Benachrichtigung an den Shop)
 *   → weiter zu Schritt 3
 * Schritt 3: Odoo-Terminbuchung als iFrame (Fallback: Redirect)
 *
 * Trigger: [data-b2b-open="quelle"] öffnet den Drawer (Quelle = Attribution),
 * [data-b2b-close] schliesst, [data-b2b-back="N"] springt zu Schritt N.
 *
 * Konfiguration via data-Attribute am <dialog> (Theme-Editor-Settings):
 * data-booking-url, data-booking-embed, data-lead-endpoint,
 * data-klaviyo-key, data-klaviyo-list.
 * ============================================================================
 */

(function () {
  'use strict';

  if (window.__mammB2bModalV2__) return;
  window.__mammB2bModalV2__ = true;

  var REDIRECT_DELAY_MS = 1200;
  var KLAVIYO_REVISION = '2024-10-15';

  // Zwischenspeicher für die Schritt-Daten (lebt pro Seitenaufruf)
  var lead = {};

  function getComponent() {
    return document.getElementById('mamm-b2b-modal');
  }

  function getDialog() {
    var component = getComponent();
    return component ? component.querySelector('dialog') : null;
  }

  /* ── Öffnen / Schliessen / Schritt-Navigation ──────────────────────── */

  function openModal(source) {
    var component = getComponent();
    var dialog = getDialog();
    if (!component || !dialog) return false;

    // Quelle für Attribution merken (landet in Klaviyo + Odoo-Lead)
    dialog.dataset.quelle = source || 'direkt';

    if (typeof component.showDialog === 'function') {
      component.showDialog();
    } else if (!dialog.open) {
      // Fallback, falls dialog-component (noch) nicht registriert ist
      dialog.showModal();
    }
    return true;
  }

  function closeModal() {
    var component = getComponent();
    var dialog = getDialog();
    if (!component || !dialog) return;

    if (typeof component.closeDialog === 'function') {
      component.closeDialog();
    } else if (dialog.open) {
      dialog.close();
    }
  }

  function showStep(dialog, step) {
    dialog.querySelectorAll('[data-b2b-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-b2b-step') !== String(step);
    });
    var booking = dialog.querySelector('[data-b2b-booking]');
    if (booking) booking.hidden = true;
    dialog.classList.remove('is-booking');

    // Submit-Buttons des Ziel-Schritts reaktivieren
    var target = dialog.querySelector('[data-b2b-step="' + step + '"]');
    if (target) {
      var submitButton = target.querySelector('[data-b2b-submit]');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }
    }

    var inner = dialog.querySelector('.mamm-b2b__inner');
    if (inner) inner.scrollTop = 0;
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest && e.target.closest('[data-b2b-open]');
    if (openTrigger) {
      var opened = openModal(openTrigger.getAttribute('data-b2b-open'));
      // Nur abfangen, wenn das Modal wirklich geöffnet wurde —
      // sonst fällt ein <a>-Trigger auf seinen href zurück (No-JS-Fallback).
      if (opened) e.preventDefault();
      return;
    }

    var closeTrigger = e.target.closest && e.target.closest('[data-b2b-close]');
    if (closeTrigger) {
      e.preventDefault();
      closeModal();
      return;
    }

    // Zurück zu Schritt N (Eingaben bleiben erhalten)
    var backTrigger = e.target.closest && e.target.closest('[data-b2b-back]');
    if (backTrigger) {
      e.preventDefault();
      var dlg = backTrigger.closest('dialog');
      if (dlg) showStep(dlg, backTrigger.getAttribute('data-b2b-back') || '1');
    }
  });

  /* ── Klaviyo Client-API (Public Key, CORS-freigegeben) ─────────────── */

  function klaviyoRequest(path, companyId, payload) {
    return fetch('https://a.klaviyo.com' + path + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION,
      },
      keepalive: true,
      body: JSON.stringify(payload),
    });
  }

  function klaviyoProfileAttributes() {
    return {
      email: lead.email,
      first_name: lead.firstName,
      last_name: lead.lastName,
      properties: {
        Firma: lead.firma || undefined,
        Branche: lead.branche || undefined,
        'Monatlicher Bedarf': lead.bedarf || undefined,
        Telefon: lead.telefon || undefined,
        Webseite: lead.webseite || undefined,
        'B2B Lead Quelle': lead.quelle,
      },
    };
  }

  function sendKlaviyoEvent(companyId, eventName, properties) {
    return klaviyoRequest('/client/events/', companyId, {
      data: {
        type: 'event',
        attributes: {
          properties: properties,
          metric: {
            data: { type: 'metric', attributes: { name: eventName } },
          },
          profile: {
            data: { type: 'profile', attributes: klaviyoProfileAttributes() },
          },
        },
      },
    });
  }

  function subscribeToList(companyId, listId) {
    return klaviyoRequest('/client/subscriptions/', companyId, {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'B2B Modal Shop',
          profile: {
            data: { type: 'profile', attributes: klaviyoProfileAttributes() },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: listId } },
        },
      },
    });
  }

  /* ── Lead-Endpoint (operations.mammpro.com → Odoo crm.lead) ────────────── */

  function sendLeadToOdoo(endpoint) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        vorname: lead.firstName,
        nachname: lead.lastName,
        email: lead.email,
        firma: lead.firma,
        branche: lead.branche,
        telefon: lead.telefon,
        bedarf: lead.bedarf,
        webseite: lead.webseite,
        quelle: lead.quelle,
        marketing: lead.marketing,
      }),
    });
  }

  /* ── E-Mail-Benachrichtigung (Shopify-Kontaktformular) ─────────────── */

  function sendContactFormEmail() {
    var contactForm = document.getElementById('mamm-b2b-contact-form');
    if (!contactForm) return null;

    var values = {
      email: lead.email,
      firma: lead.firma,
      vorname: lead.firstName,
      nachname: lead.lastName,
      telefon: lead.telefon,
      branche: lead.branche,
      bedarf: lead.bedarf,
      webseite: lead.webseite,
      quelle: lead.quelle,
      marketing: lead.marketing ? 'Ja' : 'Nein',
      body:
        'B2B-Anfrage über den Shop\n\n' +
        'Firma: ' + lead.firma + '\n' +
        'Name: ' + lead.fullName + '\n' +
        'E-Mail: ' + lead.email + '\n' +
        'Telefon: ' + lead.telefon + '\n' +
        'Branche: ' + lead.branche + '\n' +
        'Monatlicher Bedarf: ' + lead.bedarf + '\n' +
        'Webseite: ' + (lead.webseite || '—') + '\n' +
        'Quelle: ' + lead.quelle + '\n' +
        'Newsletter-Einwilligung: ' + (lead.marketing ? 'Ja' : 'Nein'),
    };

    Object.keys(values).forEach(function (key) {
      var field = contactForm.querySelector('[data-b2b-cf="' + key + '"]');
      if (field) field.value = values[key] || '';
    });

    return fetch(contactForm.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(contactForm),
      keepalive: true,
    });
  }

  /* ── Buchungs-Schritt (Schritt 3: Odoo-Kalender im Modal) ──────────── */

  function buildBookingUrl(baseUrl) {
    var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
    return (
      baseUrl +
      sep +
      'name=' + encodeURIComponent(lead.fullName) +
      '&email=' + encodeURIComponent(lead.email) +
      '&firma=' + encodeURIComponent(lead.firma || '') +
      '&telefon=' + encodeURIComponent(lead.telefon || '')
    );
  }

  function showBookingStep(dialog, url) {
    var booking = dialog.querySelector('[data-b2b-booking]');
    if (!booking) return false;

    dialog.querySelectorAll('[data-b2b-step]').forEach(function (el) {
      el.hidden = true;
    });
    booking.hidden = false;
    dialog.classList.add('is-booking');

    var external = booking.querySelector('[data-b2b-external]');
    if (external) external.href = url;

    var frame = booking.querySelector('[data-b2b-booking-frame]');
    var loading = booking.querySelector('[data-b2b-booking-loading]');
    if (!frame) return true;

    // iFrame nur (neu) laden, wenn sich die URL geändert hat
    if (frame.dataset.src !== url) {
      frame.dataset.src = url;
      if (loading) loading.hidden = false;

      // Fallback: lädt der Kalender nicht (geblockt/Netzproblem),
      // greift die klassische Weiterleitung auf dieselbe URL
      var fallbackTimer = setTimeout(function () {
        window.location.href = url;
      }, 10000);

      frame.addEventListener(
        'load',
        function () {
          clearTimeout(fallbackTimer);
          if (loading) loading.hidden = true;
        },
        { once: true }
      );

      frame.src = url;
    }

    return true;
  }

  function showSuccess(dialog, hasRedirect) {
    dialog.querySelectorAll('[data-b2b-step]').forEach(function (el) {
      el.hidden = true;
    });
    var success = dialog.querySelector('[data-b2b-success]');
    if (success) {
      success.hidden = false;
      var redirectText = success.querySelector('[data-b2b-success-redirect]');
      var fallbackText = success.querySelector('[data-b2b-success-fallback]');
      if (redirectText) redirectText.hidden = !hasRedirect;
      if (fallbackText) fallbackText.hidden = hasRedirect;
    }
  }

  /* ── Submit-Flows ───────────────────────────────────────────────────── */

  function fieldValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? String(field.value || '').trim() : '';
  }

  function logRejected(results) {
    results.forEach(function (result) {
      if (result.status === 'rejected') {
        console.warn('[mamm-b2b] Hintergrund-Request fehlgeschlagen:', result.reason);
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var form1 = e.target.closest && e.target.closest('[data-b2b-form-step1]');
    var form2 = e.target.closest && e.target.closest('[data-b2b-form-step2]');
    if (!form1 && !form2) return;

    e.preventDefault();

    var form = form1 || form2;
    var dialog = form.closest('dialog');
    if (!dialog) return;

    /* ── Schritt 1 → 2 ── */
    if (form1) {
      // Honeypot: Bots füllen das unsichtbare Feld — Anfrage still verwerfen
      var honeypot = form1.querySelector('[name="b2b_website"]');
      if (honeypot && honeypot.value) return;

      lead.firstName = fieldValue(form1, 'vorname');
      lead.lastName = fieldValue(form1, 'nachname');
      lead.fullName = (lead.firstName + ' ' + lead.lastName).trim();
      lead.email = fieldValue(form1, 'email');
      lead.quelle = dialog.dataset.quelle || 'direkt';

      // Safety-Net: auch Abbrecher nach Schritt 1 sind in Klaviyo erfasst
      var companyId = (dialog.dataset.klaviyoKey || '').trim();
      if (companyId) {
        Promise.allSettled([
          sendKlaviyoEvent(companyId, 'B2B Lead Anfrage', { Quelle: lead.quelle }),
        ]).then(logRejected);
      }

      showStep(dialog, 2);
      return;
    }

    /* ── Schritt 2 → 3 ── */
    lead.firma = fieldValue(form2, 'firma');
    lead.branche = fieldValue(form2, 'branche');
    lead.telefon = fieldValue(form2, 'telefon');
    lead.bedarf = fieldValue(form2, 'bedarf');
    lead.webseite = fieldValue(form2, 'webseite');
    // Schema ergänzen, wenn der Lead nur "mammpro.com" statt "https://mammpro.com" eingibt
    if (lead.webseite && !/^https?:\/\//i.test(lead.webseite)) {
      lead.webseite = 'https://' + lead.webseite;
    }
    lead.marketing = !!(form2.querySelector('[name="marketing"]') || {}).checked;
    lead.quelle = lead.quelle || dialog.dataset.quelle || 'direkt';

    var submitButton = form2.querySelector('[data-b2b-submit]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('is-loading');
    }

    var key = (dialog.dataset.klaviyoKey || '').trim();
    var listId = (dialog.dataset.klaviyoList || '').trim();
    var endpoint = (dialog.dataset.leadEndpoint || '').trim();
    var bookingUrl = (dialog.dataset.bookingUrl || '').trim();

    var requests = [];
    if (endpoint) {
      requests.push(sendLeadToOdoo(endpoint));
    }
    if (key) {
      requests.push(
        sendKlaviyoEvent(key, 'B2B Lead qualifiziert', {
          Firma: lead.firma,
          Branche: lead.branche,
          'Monatlicher Bedarf': lead.bedarf,
          Quelle: lead.quelle,
          'Marketing-Einwilligung': lead.marketing,
        })
      );
      if (listId && lead.marketing) {
        requests.push(subscribeToList(key, listId));
      }
    }
    var emailRequest = sendContactFormEmail();
    if (emailRequest) requests.push(emailRequest);

    // Embed-Pfad: Kalender sofort als Schritt 3 zeigen, alles andere läuft
    // im Hintergrund weiter (blockiert nie)
    var embedEnabled = dialog.dataset.bookingEmbed === 'true';
    if (bookingUrl && embedEnabled) {
      var shown = showBookingStep(dialog, buildBookingUrl(bookingUrl));
      if (shown) {
        Promise.allSettled(requests).then(logRejected);
        return;
      }
    }

    // Redirect-Pfad (Embed aus oder Buchungs-Schritt nicht verfügbar)
    Promise.allSettled(requests).then(function (results) {
      logRejected(results);

      showSuccess(dialog, !!bookingUrl);

      if (bookingUrl) {
        setTimeout(function () {
          window.location.href = buildBookingUrl(bookingUrl);
        }, REDIRECT_DELAY_MS);
      } else if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }
    });
  });
})();
